import React, { Component } from 'react';

/*
	Description: parseHtml is used to remove html tags from a string and return the parsed value.
	Parameters: WrapperComponent - any react component which you would like to return your parsed string wrapped in.
				html - the html string you wish to parse.
	Output: New component displaying the parsed text. It is also able to pass props to your WrapperComponent.
	Example Usage:  let text = '<p>This town is coming like a ghost town</p><p>All the clubs have closed down</p>'
					const newComponent = parseHTML(ScrollableText, text);
					.....
					<newComponent line={2}/>
*/
function parseHtml(WrappedComponent) {
	return class extends Component {
		constructor(props) {
			super(props);
			this.containerRef = null;
			this.state = {};
			this.setText = this.setText.bind(this);
			this.setContainerRef = this.setContainerRef.bind(this);
		}
  
		componentDidMount() {
			this.setText(this.containerRef && this.containerRef.innerText);
		}
	
		setText(innerText) {
			this.setState({
				strippedText: innerText
			});
		}

		setContainerRef(element) {
			this.containerRef = element;
		}
  
		render() {
			let {html, ...otherProps} = this.props;

			if (!this.state.strippedText) {
				return <div 
					className="html-dom-container" 
					style={{ display: "none" }} 
					ref={this.setContainerRef}
					dangerouslySetInnerHTML={ {__html: html} } />;
			} else {
				return <WrappedComponent {...otherProps}>{this.state.strippedText}</WrappedComponent>
			}
		}
	};
}

export default parseHtml;


// WEBPACK FOOTER //
// ./src/react/containers/helper/parseHtml.jsx